import React, { useMemo } from 'react'
import styled from '~/app/components/styled'
import Button, { BUTTON_SIZE, BUTTON_TYPE } from '~/app/components/common/Button/Button'
import { CategoryGroup } from '~/app/components/Cart/CartMisc/CartTabs'
import { Icon_cart_h72 } from '@yanolja-rnd/ya-com-system-icon'
import { Typography } from '@yanolja-rnd/ya-com-core'

/**
 * CartEmpty component
 * author: jaegeunlee
 * description
 */
const Container = styled.div`
  ${Typography('body2').regular};
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme }) => theme.color.white};
  width: 100%;
  height: 100%;
  max-width: ${({ theme }) => theme.unit.PC_WIDTH}px;
`
const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
`
const EmptyCartIcon = styled.div`
  margin-bottom: 1.2rem;
  svg > path {
    fill: ${({ theme }) => theme.color.gray400};
  }
`
const NoItemText = styled.div`
  width: 100%;
  text-align: center;
  ${Typography('subtitle3').regular};
  color: ${({ theme }) => theme.color.gray900};
`
const AddItemText = styled.div`
  width: 100%;
  text-align: center;
  margin-top: 0.4rem;
  ${Typography('body1').regular};
  color: ${({ theme }) => theme.color.gray600};
`
const ButtonWrapper = styled.div`
  padding-top: 1.6rem;
  width: 16rem;
`

interface CartEmptyProps {
  tab: CategoryGroup
  onHomeClick?: () => void
  onAccommodationClick?: () => void
  onTicketClick?: () => void
  onTransportationClick?: () => void
}

const CartEmpty: React.FC<CartEmptyProps> = ({
  tab,
  onHomeClick,
  onAccommodationClick,
  onTicketClick,
  onTransportationClick,
}) => {
  const empty = useMemo(() => {
    if (tab === CategoryGroup.ALL) {
      return {
        noItemText: '아직 장바구니가 비어있어요',
        addItemText: '원하는 상품을 담아두면 한 번에 예약할 수 있어요.',
        buttonText: '담으러 가기',
        action: onHomeClick,
      }
    } else if (tab === CategoryGroup.ACCOMMODATION) {
      return {
        noItemText: '아직 장바구니가 비어있어요',
        addItemText: '원하는 상품을 담아두면 한 번에 예약할 수 있어요.',
        buttonText: '국내숙소 검색하기',
        action: onAccommodationClick,
      }
    } else if (tab === CategoryGroup.TICKET) {
      return {
        noItemText: '아직 장바구니가 비어있어요',
        addItemText: '원하는 상품을 담아두면 한 번에 예약할 수 있어요.',
        buttonText: '국내레저 검색하기',
        action: onTicketClick,
      }
    } else {
      return {
        noItemText: '아직 장바구니가 비어있어요',
        addItemText: '원하는 상품을 담아두면 한 번에 예약할 수 있어요.',
        buttonText: '교통 둘러보기',
        action: onTransportationClick,
      }
    }
  }, [tab])
  return (
    <Container>
      <ContentWrapper>
        <EmptyCartIcon>
          <Icon_cart_h72 />
        </EmptyCartIcon>
        <NoItemText>{empty.noItemText}</NoItemText>
        <AddItemText>{empty.addItemText}</AddItemText>
        <ButtonWrapper>
          <Button
            type={BUTTON_TYPE.BLUE}
            size={BUTTON_SIZE.M}
            title={empty.buttonText}
            isFullSize={true}
            onClick={() => empty.action?.()}
          />
        </ButtonWrapper>
      </ContentWrapper>
    </Container>
  )
}

export default CartEmpty
